import { useUiState } from 'state';

export default () => {
  const { updateUiState } = useUiState();
  return (props) =>
    updateUiState({
      confirmationDialog:
        props.hide === true
          ? undefined
          : {
              title: props.title,
              width: props.width,
              maxWidth: props.maxWidth,
              description: props.description,
              contentStyle: props.contentStyle,
              cancelWidth: props.cancelWidth,
              cancelLabel: props.cancelLabel,
              confirmWidth: props.confirmWidth,
              confirmLabel: props.confirmLabel,
              onCancel: props.onCancel,
              onConfirm: props.onConfirm,
              hideCancel: props.hideCancel
            }
    });
};
